<div class="photo-container">
  <img
    alt="photo"
    [src]="photoSrc"
    (click)="inputFile.click()"
    [class.pointer]="isEditable"
  />
  <input
    type="file"
    accept="image/png, image/jpeg"
    (change)="handleFileInput($event)"
    hidden
    #inputFile
  />
</div>
